import { z } from 'zod';

const ExitProofCarrierAddressSchema = z.object({
  street: z.string().optional(),
  postCode: z.string().optional(),
  city: z.string().optional(),
  country: z.string().optional(),
});

const ExitProofCarrierSchema = z.object({
  name: z.string().optional(),
  identificationNumber: z.string().optional(),
  address: ExitProofCarrierAddressSchema.optional(),
});

const ExitProofTransportDocumentsSchema = z.object({
  type: z.string().optional(),
  referenceNumber: z.string().optional(),
});

const ExitProofAdditionalInformationRelationSchema = z.object({
  pointers: z.array(z.number()).optional(),
});

const ExitProofAdditionalInformationSchema = z.object({
  type: z.string().optional(),
  code: z.string().optional(),
  relation: ExitProofAdditionalInformationRelationSchema.optional(),
});

export const ExitProofLogsSchema = z.object({
  exitOffice: z.string().optional(),
  exitDate: z.string().optional().nullable(),
  transportDocuments: z.array(ExitProofTransportDocumentsSchema).optional(),
  additionalInformation: z.array(ExitProofAdditionalInformationSchema).optional(),
  carrier: ExitProofCarrierSchema.optional(),
});

export type ExitProofLogsInput = z.infer<typeof ExitProofLogsSchema>;
